module.exports = __webpack_public_path__ + "static/media/ptl.2577aa5c.webp";